import { useMemo } from 'react';
import { Form, Formik } from 'formik';
import { useAccount, useMsal } from '@azure/msal-react';
import { Modal } from '@shared/components/modals/Modal';
import { formatDate } from '@shared/commonFunctions';
import { dateFormatWithTime } from '@shared/constants/formats';
import { communicationValidationSchema } from '../../validations';
import { CommunicateForm } from './CommunicationForm';
import { CommunicateFormType, NoteTypeEnum } from './types';

interface ICommunicationModalModalProps {
  handleSubmit: (data: CommunicateFormType) => Promise<void> | void;
  handleClose: () => void;
  loading: boolean;
}

export const CommunicationModal = ({loading, handleSubmit, handleClose }: ICommunicationModalModalProps) => {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const initialCommunicationState = useMemo(
    () => ({
      type: NoteTypeEnum.Call_Email_Text,
      date: formatDate(new Date().toISOString(), { format: dateFormatWithTime }),
      createdBy: account?.name || '',
      notes: '',
    }),
    [account?.name]
  );

  return (
    <Modal
      open
      title="Add Communication"
      dialogWidth="60vw"
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialCommunicationState as CommunicateFormType}
        validationSchema={communicationValidationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form onSubmit={props.handleSubmit}>
            <CommunicateForm
              loading={loading}
              handleClose={handleClose}
              {...props}
            />
          </Form>
        )}
      </Formik>
    </Modal>
  );
};
